import AuthService from '@/app/services/auth'
import { ErrorResponse } from '@/types/api'
import { useMutation, useQueryClient } from 'react-query'

export function useAuthLogout() {
  const queryClient = useQueryClient()

  return useMutation<void, ErrorResponse, void>(
    AuthService.POST_PATH_LOGOUT,
    AuthService.logout,
    {
      onSuccess: async () => {
        await queryClient.cancelQueries()
        queryClient.clear()
      },
    }
  )
}
